"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.validation.nameRequired': 'Il nome del tutorial è obbligatorio',
    'tutorial.validation.sectionsRequired': 'È richiesta almeno una sezione',
    'tutorial.validation.sectionTitleRequired': 'Il titolo della sezione {index} è obbligatorio',
    'tutorial.validation.stepsRequired': 'È richiesto almeno un passo',
    'tutorial.validation.stepTitleRequired': 'Il titolo del passo {index} è obbligatorio',
    'tutorial.validation.stepSectionsRequired': 'Il passo {index} deve avere almeno una sezione',
};
